import { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import { ChromePicker} from 'react-color';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import "./ColorPicker.scss";

export default function ColorPicker(props) {

    const [, setColor] = useState(props.color);
    const className = 'colorPicker';

    useEffect(() => {
        setColor(props.color);
    }, [props])

    return (
        <Menu
            open={props.showColorMenu}
            onClose={props.handleColorPickerMenu}
            anchorEl={props.anchorColorMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <div className={className}>
                <ChromePicker
                    color={props?.color}
                    onChangeComplete={props.handleColorChange}/>
            </div>
        </Menu>
    );
}

ColorPicker.defaultProps = {
  color: '#2784B9'
}
